import React from 'react';

import styled from 'styled-components';

import { HeaderOnboardingProgressIcon } from './components/HeaderOnboardingProgressIcon/HeaderOnboardingProgressIcon';
import HeaderUserProfileDropdown from './components/HeaderUserProfileDropdown/HeaderUserProfileDropdown';

import { Flex, Spacer } from '@aircall/tractor';
import { SupportLinksDropdown } from '@components/SupportLinksDropdown/SupportLinksDropdown';
import { color, variable } from '@helpers/style.helpers';
import { useFeatures } from '@hooks/useFeatures/useFeatures';
import { useReseller } from '@hooks/useReseller/useReseller';

export const StyledHeader = styled(Flex)`
  align-items: center;
  justify-content: flex-end;
  padding-right: ${variable.space.s}px;
  border-bottom: 1px solid ${color.grey.base};
  background-color: ${color.base.white};
`;

const Header = React.memo(() => {
  const { isSupportLinksAllowed, showReferAFriendButton } = useFeatures();

  const { isReseller } = useReseller();

  const displayReferAFriendButton = showReferAFriendButton && !isReseller;

  return (
    <StyledHeader height='100%' data-test='app-header'>
      <Spacer space='l' alignItems='center'>
        <HeaderOnboardingProgressIcon />
        {isSupportLinksAllowed && <SupportLinksDropdown />}
        <HeaderUserProfileDropdown showReferAFriendButton={displayReferAFriendButton} />
      </Spacer>
    </StyledHeader>
  );
});

export default Header;
